// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22zwq","label":"styles_label__2tUcF"};